import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { initAnalytics, trackPageView } from './lib/analytics';
import './App.css';

// Lazy-loaded pages for code splitting
const MainPage = lazy(() => import('./pages/MainPage'));
const WorkWithMePage = lazy(() => import('./pages/WorkWithMePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));

function AnalyticsPageTracker() {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();

    const timer = window.setTimeout(() => {
      trackPageView({
        path: `${location.pathname}${location.search}${location.hash}`,
        title: document.title,
        location: window.location.href
      });
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsPageTracker />
      <Header />
      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen text-primary">
            Loading...
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/work-with-me" element={<WorkWithMePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  );
}

export default App;
